/* ==========================================================================
   Hatha Bags — JS del tema
   Sin dependencias externas. Todo se engancha por atributos data-*.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.hatha && window.hatha.routes) || {};

  /* --------------------------------------------------------------- Utiles */

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function on(event, selector, handler) {
    document.addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target) handler(e, target);
    });
  }

  function formatMoney(cents) {
    var format = (window.hatha && window.hatha.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  /* ------------------------------------------------------- Menu movil */

  function lockScroll(locked) {
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  on('click', '[data-menu-open]', function () {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    menu.dataset.open = 'true';
    menu.setAttribute('aria-hidden', 'false');
    lockScroll(true);
  });

  on('click', '[data-menu-close]', function () {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    menu.dataset.open = 'false';
    menu.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  });

  /* ------------------------------------------------------ Carrito lateral */

  function openCart() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.dataset.open = 'true';
    lockScroll(true);
    var closeBtn = $('[data-cart-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }

  function closeCart() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.dataset.open = 'false';
    lockScroll(false);
  }

  on('click', '[data-cart-open]', function (e) {
    e.preventDefault();
    openCart();
  });

  on('click', '[data-cart-close]', function (e) {
    e.preventDefault();
    closeCart();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    var menu = $('[data-mobile-menu]');
    if (menu && menu.dataset.open === 'true') {
      menu.dataset.open = 'false';
      menu.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    }
  });

  /* Vuelve a pedir el HTML del carrito y sustituye cuerpo + pie. */
  function refreshCart() {
    return fetch(window.location.pathname + '?sections=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newBody = $('[data-cart-body]', parsed);
        var newFoot = $('[data-cart-foot]', parsed);
        var body = $('[data-cart-body]');
        var foot = $('[data-cart-foot]');

        if (newBody && body) body.innerHTML = newBody.innerHTML;
        if (foot) foot.innerHTML = newFoot ? newFoot.innerHTML : '';

        return fetch(routes.cart_url + '.js');
      })
      .then(function (r) {
        return r ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var counter = $('[data-cart-count]');
        if (!counter) return;
        counter.textContent = cart.item_count;
        counter.hidden = cart.item_count === 0;
      })
      .catch(function (err) {
        console.error('[hatha] no se pudo actualizar el carrito', err);
      });
  }

  /* Los cambios se mandan de uno en uno y el carrito se refresca al final.
     Una bolsa personalizada son dos lineas -la bolsa y el recargo-, y hay que
     moverlas juntas. Se identifican por 'key' y no por numero de linea: la key
     no cambia aunque se borren otras lineas. */
  function applyChanges(changes) {
    var chain = Promise.resolve();

    changes.forEach(function (change) {
      chain = chain.then(function () {
        return fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(change)
        });
      });
    });

    return chain.then(refreshCart);
  }

  /* La bolsa primero -por si hay que caer al numero de linea, que si se
     desplaza- y despues su recargo, con tantas unidades por bolsa como
     letras y simbolos de pago tenga. */
  function lineChanges(el, quantity) {
    var changes = [];

    if (el.dataset.key) {
      changes.push({ id: el.dataset.key, quantity: quantity });
    } else {
      changes.push({ line: parseInt(el.dataset.line, 10), quantity: quantity });
    }

    if (el.dataset.addonKey) {
      var unit = parseInt(el.dataset.addonUnit, 10) || 0;
      changes.push({
        id: el.dataset.addonKey,
        quantity: quantity > 0 ? unit * quantity : 0
      });
    }

    return changes;
  }

  on('click', '[data-cart-remove]', function (e, el) {
    e.preventDefault();
    applyChanges(lineChanges(el, 0));
  });

  on('change', '[data-cart-qty]', function (e, el) {
    var qty = parseInt(el.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    applyChanges(lineChanges(el, qty));
  });

  /* Botones +/- de cualquier control de cantidad */
  on('click', '[data-qty-up], [data-qty-down]', function (e, el) {
    e.preventDefault();
    var wrap = el.closest('.qty');
    var input = wrap && $('input', wrap);
    if (!input) return;

    var step = el.hasAttribute('data-qty-up') ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;

    var next = (parseInt(input.value, 10) || min) + step;
    if (next < min) next = min;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------ Anadir al carrito */

  /* Huella estable de una linea: mismo producto y mismas opciones dan la misma
     clave, para que dos bolsas identicas se sigan juntando en una sola linea
     del carrito en vez de apilarse sueltas. */
  function lineKey(seed) {
    var hash = 5381;
    for (var i = 0; i < seed.length; i++) {
      hash = ((hash * 33) ^ seed.charCodeAt(i)) >>> 0;
    }
    return hash.toString(36);
  }

  /* El caso normal es mandar el propio formulario. Solo cuando hay recargo
     -letras adicionales o simbolos- Y la tienda tiene configurada la variante
     de recargo se cambia a JSON, que es la unica forma de meter dos lineas de
     golpe.

     Las dos lineas van enlazadas por _hatha_key / _hatha_parent para poder
     pintarlas juntas en el carrito. Las propiedades que empiezan por guion
     bajo no se le ensenan al cliente. */
  function buildAddRequest(form) {
    var plain = {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form)
    };

    var root = $('[data-personalize]', form.closest('.product__info') || document);
    if (!root || !root.dataset.addonVariant) return plain;

    var extra = chargeableChars(root);
    if (extra <= 0) return plain;

    var data = new FormData(form);
    var quantity = parseInt(data.get('quantity'), 10) || 1;
    var properties = {};

    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim() !== '') properties[match[1]] = value;
    });

    var names = Object.keys(properties).sort();
    var key = lineKey(data.get('id') + '|' + JSON.stringify(properties, names));
    properties['_hatha_key'] = key;

    var initials = $('[data-personalize-initials]', root);
    var addonProps = { _hatha_parent: key };
    if (initials && initials.value) addonProps['_iniciales'] = initials.value;

    var items = [
      { id: data.get('id'), quantity: quantity, properties: properties },
      {
        id: root.dataset.addonVariant,
        quantity: extra * quantity,
        properties: addonProps
      }
    ];

    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({ items: items })
    };
  }

  on('submit', '[data-product-form]', function (e, form) {
    e.preventDefault();

    var button = $('[data-add-to-cart]', form);
    var errorEl = $('[data-form-error]', form);
    var original = button ? button.textContent : '';

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.textContent = '...';
    }

    var request = buildAddRequest(form);

    fetch(routes.cart_add_url, request)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || data.message);
        }
        return refreshCart().then(openCart);
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.textContent = original;
        }
      });
  });

  /* -------------------------------------------------- Selector de variantes */

  function initVariantPicker(root) {
    var data = $('[data-variants-json]', root);
    if (!data) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (err) {
      return;
    }

    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-variant-price]', root);
    var skuEl = $('[data-variant-sku]', root);
    var button = $('[data-add-to-cart]', root);
    var selectedLabels = $$('[data-option-selected]', root);
    var strings = (window.hatha && window.hatha.strings) || {};

    function selectedOptions() {
      return $$('input[data-option-index]:checked', root)
        .sort(function (a, b) {
          return a.dataset.optionIndex - b.dataset.optionIndex;
        })
        .map(function (input) {
          return input.value;
        });
    }

    function update() {
      var chosen = selectedOptions();

      selectedLabels.forEach(function (label) {
        var i = parseInt(label.dataset.optionSelected, 10);
        label.textContent = chosen[i] || '';
      });

      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === chosen[i];
        });
      });

      if (!match) {
        if (button) {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = strings.unavailable || 'No disponible';
        }
        return;
      }

      if (idInput) idInput.value = match.id;

      if (priceEl) {
        if (match.price === 0) {
          priceEl.innerHTML =
            '<span class="price price--pending">' +
            (priceEl.dataset.pendingLabel || 'Precio proximamente') +
            '</span>';
        } else if (match.compare_at_price && match.compare_at_price > match.price) {
          priceEl.innerHTML =
            '<span class="price"><span class="price__sale">' +
            formatMoney(match.price) +
            '</span><s class="price__compare">' +
            formatMoney(match.compare_at_price) +
            '</s></span>';
        } else {
          priceEl.innerHTML =
            '<span class="price">' + formatMoney(match.price) + '</span>';
        }
      }

      if (skuEl) skuEl.textContent = match.sku || '';

      if (button) {
        if (match.available) {
          button.removeAttribute('aria-disabled');
          button.textContent = strings.addToCart || 'Anadir al carrito';
        } else {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = strings.soldOut || 'Agotado';
        }
      }

      // Cambia la imagen principal si la variante tiene foto propia
      if (match.featured_media_id) {
        var thumb = $(
          '[data-media-id="' + match.featured_media_id + '"]',
          root.closest('.product') || document
        );
        if (thumb) thumb.click();
      }

      // Refleja la variante en la URL sin recargar
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('input[data-option-index]', root).forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();
  }

  /* --------------------------------------------------- Galeria de producto */

  on('click', '[data-thumb]', function (e, el) {
    e.preventDefault();
    var main = $('[data-main-image]');
    if (!main) return;

    main.src = el.dataset.full;
    main.alt = el.dataset.alt || '';

    $$('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', String(t === el));
    });
  });

  /* --------------------------------------------------------- Personalizacion */

  /* Cuenta solo letras y numeros: los espacios, los puntos de unas iniciales
     escritas "A.G.M." y los simbolos no entran aqui. Los simbolos se cuentan
     aparte porque nunca van incluidos en las letras de regalo. */
  function countLetters(value) {
    var letters = (value || '').replace(/[^\p{L}\p{N}]/gu, '');
    return letters.length;
  }

  /* Simbolos disponibles, leidos de los propios botones: caracter -> nombre. */
  function symbolMap(root) {
    var map = {};
    $$('[data-personalize-symbol]', root).forEach(function (btn) {
      var glyph = btn.dataset.symbol;
      if (glyph) map[glyph] = btn.dataset.symbolName || glyph;
    });
    return map;
  }

  /* Nombres de los simbolos escritos en las iniciales, en el orden en que
     aparecen. Se recorre el texto en vez de contar caracteres sueltos para
     que un simbolo de mas de un caracter tambien valga. */
  function usedSymbols(root) {
    var input = $('[data-personalize-initials]', root);
    var toggle = $('[data-personalize-toggle]', root);
    if (!input || (toggle && !toggle.checked)) return [];

    var map = symbolMap(root);
    var chars = Object.keys(map).sort(function (a, b) {
      return b.length - a.length;
    });

    var value = input.value || '';
    var found = [];
    var i = 0;

    while (i < value.length) {
      var hit = '';
      for (var s = 0; s < chars.length; s++) {
        if (value.substr(i, chars[s].length) === chars[s]) {
          hit = chars[s];
          break;
        }
      }

      if (hit) {
        found.push(map[hit]);
        i += hit.length;
      } else {
        i += 1;
      }
    }

    return found;
  }

  function extraLetters(root) {
    var input = $('[data-personalize-initials]', root);
    var toggle = $('[data-personalize-toggle]', root);
    if (!input || (toggle && !toggle.checked)) return 0;

    var free = parseInt(root.dataset.freeChars, 10);
    if (isNaN(free)) free = 0;

    var extra = countLetters(input.value) - free;
    return extra > 0 ? extra : 0;
  }

  /* Todo lo que se cobra: letras de mas + simbolos. Es tambien el numero de
     unidades del producto de recargo que hay que meter en el carrito. */
  function chargeableChars(root) {
    return extraLetters(root) + usedSymbols(root).length;
  }

  /* Precio del recargo, en centavos, para una unidad del producto. */
  function extraCost(root) {
    var letterPrice = parseInt(root.dataset.extraPrice, 10);
    if (isNaN(letterPrice) || letterPrice < 0) letterPrice = 0;

    var symbolPrice = parseInt(root.dataset.symbolPrice, 10);
    if (isNaN(symbolPrice) || symbolPrice < 0) symbolPrice = letterPrice;

    return extraLetters(root) * letterPrice + usedSymbols(root).length * symbolPrice;
  }

  function refreshPersonalization(root) {
    var strings = (window.hatha && window.hatha.strings) || {};
    var count = chargeableChars(root);
    var cost = extraCost(root);
    var symbols = usedSymbols(root);

    var costEl = $('[data-personalize-cost]', root);
    if (costEl) {
      var template = strings.personalizationCost;
      if (count === 1 && strings.personalizationCostOne) {
        template = strings.personalizationCostOne;
      }

      if (cost > 0 && template) {
        costEl.innerHTML = template
          .replace('__count__', String(count))
          .replace('__amount__', formatMoney(cost));
      } else {
        costEl.textContent = strings.personalizationCostZero || '';
      }
    }

    /* Queda escrito en el pedido aunque la tienda no tenga configurado el
       producto de recargo: asi Ana ve siempre cuantos extras hay. */
    var extraEl = $('[data-personalize-extra]', root);
    if (extraEl) {
      extraEl.value = count > 0 ? String(count) : '';
    }

    /* Y los simbolos por su nombre, que en el pedido se lee mejor que el
       caracter suelto. */
    var symbolsEl = $('[data-personalize-symbols]', root);
    if (symbolsEl) {
      symbolsEl.value = symbols.join(', ');
    }
  }

  on('change', '[data-personalize-toggle]', function (e, el) {
    var root = el.closest('.personalize');
    var body = root && $('[data-personalize-body]', root);
    if (!body) return;

    body.dataset.open = el.checked ? 'true' : 'false';

    if (el.checked) {
      /* El color de la letra hay que elegirlo si o si, asi que al abrir la
         personalizacion se marca el que venga con data-default. Solo si el
         grupo esta entero sin marcar: si el cliente ya eligio y vuelve a
         abrir, se respeta lo suyo. */
      var radios = $$('input[type="radio"]', body);
      var marcados = {};
      radios.forEach(function (input) {
        if (input.checked) marcados[input.name] = true;
      });
      radios.forEach(function (input) {
        if (input.hasAttribute('data-default') && !marcados[input.name]) {
          input.checked = true;
          marcados[input.name] = true;
        }
      });
    } else {
      // Si se desactiva, se limpian los campos para no mandar propiedades vacias
      $$('input[type="text"]', body).forEach(function (input) {
        input.value = '';
      });
      $$('input[type="radio"]', body).forEach(function (input) {
        input.checked = false;
      });
    }

    refreshPersonalization(root);
  });

  on('input', '[data-personalize-initials]', function (e, el) {
    var root = el.closest('.personalize');
    if (root) refreshPersonalization(root);
  });

  /* Donde estaba el cursor la ultima vez, para insertar el simbolo ahi y no
     siempre al final. Si el campo tiene el foco vale lo que diga el navegador;
     si no, lo ultimo que se apunto al salir de el. */
  function rememberCaret(el) {
    el.dataset.caret = el.selectionStart;
    el.dataset.caretEnd = el.selectionEnd;
  }

  ['keyup', 'click', 'focusout'].forEach(function (event) {
    on(event, '[data-personalize-initials]', function (e, el) {
      rememberCaret(el);
    });
  });

  function caretOf(input) {
    if (document.activeElement === input) {
      return { start: input.selectionStart, end: input.selectionEnd };
    }

    var start = parseInt(input.dataset.caret, 10);
    var end = parseInt(input.dataset.caretEnd, 10);
    if (isNaN(start)) return { start: input.value.length, end: input.value.length };
    if (isNaN(end) || end < start) end = start;

    return { start: start, end: end };
  }

  /* Con el raton, no soltar el foco del campo al pulsar el simbolo: asi el
     cursor sigue donde estaba y se ve donde ha caido el dibujo. */
  on('mousedown', '[data-personalize-symbol]', function (e) {
    e.preventDefault();
  });

  on('click', '[data-personalize-symbol]', function (e, el) {
    e.preventDefault();

    var root = el.closest('.personalize');
    var input = root && $('[data-personalize-initials]', root);
    var symbol = el.dataset.symbol;
    if (!input || !symbol) return;

    var caret = caretOf(input);
    var value = input.value || '';
    var next = value.slice(0, caret.start) + symbol + value.slice(caret.end);

    var max = parseInt(input.getAttribute('maxlength'), 10);
    if (!isNaN(max) && next.length > max) {
      input.focus();
      return;
    }

    input.value = next;
    input.focus();

    var position = caret.start + symbol.length;
    input.setSelectionRange(position, position);
    rememberCaret(input);

    refreshPersonalization(root);
  });

  /* --------------------------------------------------------------- Acordeon */

  on('click', '.accordion__trigger', function (e, el) {
    var expanded = el.getAttribute('aria-expanded') === 'true';
    el.setAttribute('aria-expanded', String(!expanded));
    var panel = document.getElementById(el.getAttribute('aria-controls'));
    if (panel) panel.hidden = expanded;
  });

  /* ------------------------------------------------ Ordenar / filtrar coleccion */

  on('change', '[data-sort-by]', function (e, el) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', el.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  on('change', '[data-filter]', function (e, el) {
    var url = new URL(window.location.href);
    if (el.value) {
      url.searchParams.set(el.name, el.value);
    } else {
      url.searchParams.delete(el.name);
    }
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ------------------------------------------------- Aparicion al hacer scroll */

  function initReveal() {
    var items = $$('.reveal:not(.is-visible)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------------- Arranque */

  function init() {
    $$('[data-variant-picker]').forEach(initVariantPicker);
    $$('[data-personalize]').forEach(refreshPersonalization);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas de Shopify recarga secciones sueltas
  document.addEventListener('shopify:section:load', init);
})();
